import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.services';
import { Component } from '@angular/core';
import { MenuService } from '../../services/menu.services';
import { Globals } from 'app/globals/globals';

@Component({
  selector: 'app-header-no-sidebar',
  templateUrl: './app-header-no-sidebar.component.html'
})
export class AppHeaderNoSidebarComponent {
  mMenus: any = [];

  constructor(
    private auth: AuthService,
    private translate: TranslateService,
    private menu: MenuService,
    private global: Globals
  ) {}
  logout() {
    this.auth.logout();
  }
  changeLanguage(lang) {
    this.translate.use(lang);
    window.localStorage.setItem('tokenLanguage', lang);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-header-no-sidebar/app-header-no-sidebar.component.ts